import { Button } from "@mui/material";
import React from "react";

const STATUS_CHIPS = [
  { value: "0", label: "All", countKey: "all" },
  { value: "1", label: "Active", countKey: "active" },
  { value: "2", label: "Inactive", countKey: "inactive" },
];

const chipClass = (selected) =>
  `px-3 py-1 rounded-full text-sm font-medium border transition-colors ${
    selected
      ? "bg-slate-800 border-slate-800 text-white"
      : "bg-white border-gray-300 text-gray-700 hover:bg-gray-100"
  }`;

const Filters = ({
  view,
  counts,
  onViewChange,
  filterByStatus,
  sortBy,
  searchQuery,
  doSetFilterByStatus,
  doSetSortBy,
  doSetSearchQuery,
  onAddMember,
  onPrint,
}) => {
  const isArchived = view === "archived";

  return (
    <div className="p-4 space-y-3 filter-container">
      <div className="flex flex-wrap items-center gap-3">
        <div
          role="tablist"
          aria-label="Customer list"
          className="inline-flex rounded-lg bg-gray-100 p-1"
        >
          {[
            { value: "members", label: "Members", count: counts.all },
            { value: "archived", label: "Archived", count: counts.archived },
          ].map((tab) => (
            <button
              key={tab.value}
              type="button"
              role="tab"
              aria-selected={view === tab.value}
              onClick={() => onViewChange(tab.value)}
              className={`px-4 py-1.5 rounded-md text-sm font-semibold transition-colors ${
                view === tab.value
                  ? "bg-white shadow text-slate-900"
                  : "text-gray-600 hover:text-slate-900"
              }`}
            >
              {tab.label}{" "}
              <span className="text-xs font-normal text-gray-500">
                {tab.count}
              </span>
            </button>
          ))}
        </div>

        <div className="relative flex-grow min-w-56 max-w-md">
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          >
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.5-3.5" />
          </svg>
          <input
            type="text"
            aria-label="Search"
            placeholder="Search name, phone, email, city"
            className="w-full border rounded-lg border-gray-300 py-1.5 pl-9 pr-8 text-sm"
            value={searchQuery}
            onChange={(e) => doSetSearchQuery(e.target.value)}
          />
          {searchQuery ? (
            <button
              type="button"
              aria-label="Clear search"
              onClick={() => doSetSearchQuery("")}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 text-lg leading-none"
            >
              ×
            </button>
          ) : null}
        </div>

        <div className="flex items-center gap-2 ml-auto">
          {!isArchived && (
            <Button
              type="button"
              variant="contained"
              color="success"
              onClick={onAddMember}
            >
              Add Member
            </Button>
          )}
          <Button type="button" variant="outlined" onClick={onPrint}>
            Print
          </Button>
        </div>
      </div>

      {!isArchived && (
        <div className="flex flex-wrap items-center gap-2">
          {STATUS_CHIPS.map((chip) => (
            <button
              key={chip.value}
              type="button"
              aria-pressed={filterByStatus === chip.value}
              onClick={() => doSetFilterByStatus(chip.value)}
              className={chipClass(filterByStatus === chip.value)}
            >
              {chip.label} {counts[chip.countKey]}
            </button>
          ))}
          <label className="ml-auto flex items-center gap-2 text-sm text-gray-600">
            Sort by
            <select
              aria-label="Sort by"
              className="border p-1 rounded-md border-gray-300 text-gray-900"
              value={sortBy}
              onChange={(e) => doSetSortBy(e.target.value)}
            >
              <option value="name">Name</option>
              <option value="id">Customer ID</option>
              <option value="city">City</option>
              <option value="street_name">Street</option>
            </select>
          </label>
        </div>
      )}
    </div>
  );
};

export default Filters;
